import React from 'react';

export const TrainingRegisterResourceManagementContext = React.createContext();

export const useTrainingRegisterResources = () =>
  React.useContext(TrainingRegisterResourceManagementContext);
